import React, { useState } from "react";
import {  Col,  Form,  Input,  Modal, theme,  Row,  Spin,  Space, Select, InputNumber, Divider ,} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { PATCH, POST  } from "../../frameworks/HttpClient";
import { URL_PRODUCT, URL_SKIM } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import { PRODUCT_TYPE } from "../../constants/string";
import _ from 'lodash';
import useDropdownItem from "../../common/useDropdownItem";
import ColorButton from "../../common/ColorButton";

export default function AddStockSkimModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages, setErrorMessages] = useState(null);
  const productWatch = Form.useWatch('product', form)

  const [debouncedTransction, setDebouncedTransction] = React.useState('');
  const transactionDropdown = useDropdownItem({ 
    manual: true,
    url: URL_SKIM.SKIM_PRODUCE_TRANSACTION, 
    label: 'name', 
    value:'id', 
    pagination: true, 
    params: { page_size: 50, lot_no : debouncedTransction, product : productWatch ? productWatch : ''} ,
    label: 'lot_no'
  })
  const debounceTransction = React.useCallback(_.debounce((_searchVal) => { setDebouncedTransction(_searchVal) }, 800), []);

  const [debouncedProduct, setDebouncedProduct] = React.useState('');
  const productDropdown = useDropdownItem({ 
    manual: true,
    url: URL_PRODUCT.PRODUCT, 
    label_renderer : (e) => e.short_name ? `${e.name} - ${e.short_name}` : `${e.name}`, 
    value:'id', 
    pagination: true, 
    params: { page_size: 50, lot_no : debouncedProduct, type : PRODUCT_TYPE.SKIM} ,
    label_renderer: (e) => `${e.name} - ${e.short_name}`
  })
  const debounceProduct = React.useCallback(_.debounce((_searchVal) => { setDebouncedProduct(_searchVal) }, 800), []);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      
      // validate sources
      if(!target){
        if(!data.sources || _.size(data.sources) === 0){
          setErrorMessages('กรุณากรอกข้อมูลล็อตการผลิต')
          return;
        }
      }

      if (target?.id) {
        await PATCH(`${URL_SKIM.SKIM_STOCK}${target.id}/`, data);
      } else {
        await POST(URL_SKIM.SKIM_STOCK, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if(open)
      transactionDropdown.fetchOptions();
      productDropdown.fetchOptions();
  },[open])

  React.useEffect(() => {
    if(open)
      transactionDropdown.fetchOptions();
  },[debouncedTransction])

  React.useEffect(() => {
    if(open)
      productDropdown.fetchOptions();
  },[debouncedProduct])

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  React.useEffect(() => {
    if(open){
      form.setFieldsValue({ sources: [] });
      transactionDropdown.fetchOptions();
    }
  },[productWatch])

  React.useEffect(() => {
    if (open) {
      if(target?.id){
        form.setFieldsValue({ old_sources : target.sources ? target.sources : []});
        form.setFieldsValue(target);
      }
    } else {
      form.resetFields();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขพาเลท" : "เพิ่มพาเลท"}
      width={450}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages} />

      <Form form={form} layout="vertical">
        <Row gutter={10}>
          <Col span={24}>
            <Form.Item
              label="เลขที่พาเลท"
              name="stock_no"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Input placeholder="เลขที่พาเลท"/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="สินค้า"
              name="product"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Select
                showSearch
                allowClear
                disabled={target?.id ? true : false}
                placeholder={"สินค้า"}
                options={productDropdown.options}
                filterOption={false}
                style={{ width : '100%'}}
                notFoundContent={productDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceProduct}
              /> 
            </Form.Item>
          </Col>
          {productWatch && <Divider style={{ marginTop : 0}}>
            ล็อตการผลิต
          </Divider>}

        {/* OldSorces */}
        <Form.List name="old_sources" >
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  <Form.Item
                    label={'ล็อตการผลิต'}
                    {...restField}
                    name={[name, 'transaction']}
                  >
                    <Select
                      showSearch
                      disabled={true}
                      allowClear
                      placeholder={"ล็อตการผลิต"}
                      filterOption={false}
                      style={{ width : 200}}
                      notFoundContent={transactionDropdown.loading ? <Spin size="small" /> : "-"}
                      onSearch={debounceTransction}
                      options={transactionDropdown.options}
                    /> 
                  </Form.Item>
                  <Form.Item
                    label={'จำนวน'}
                    {...restField}
                    name={[name, 'amount']}
                  >
                    <InputNumber placeholder="จำนวน" style={{ width : '100%'}} disabled={true}/>
                  </Form.Item>
                </Space>
              ))}
            </>
          )}
        </Form.List>

        {/* NewSorces */}
        <Form.List name="sources" >
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  <Form.Item
                    label={'ล็อตการผลิต'}
                    {...restField}
                    name={[name, 'transaction']}
                    rules={[{ required: true, message: 'กรุณากรอกล็อต' }]}
                  >
                    <Select
                      showSearch
                      allowClear
                      placeholder={"ล็อตการผลิต"}
                      filterOption={false}
                      style={{ width : 200}}
                      notFoundContent={transactionDropdown.loading ? <Spin size="small" /> : "-"}
                      onSearch={debounceTransction}
                      options={_.filter(transactionDropdown.options,item => item.is_completed === false)}
                    /> 
                  </Form.Item>
                  <Form.Item
                    label={'จำนวน'}
                    {...restField}
                    name={[name, 'amount']}
                    rules={[{ required: true, message: 'กรุณากรอกจำนวน' }]}
                  >
                    <InputNumber placeholder="จำนวน" style={{ width : '100%'}}/>
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item style={{ width : '100%' }} hidden={!productWatch}>
                <center>
                  <ColorButton type="dashed" onClick={() => add()} block icon={<PlusOutlined />} style={{ width : 200}} >
                    เพิ่มล็อตการผลิต
                  </ColorButton>
                </center>
              </Form.Item>
            </>
          )}
        </Form.List>
        </Row>
      </Form>
    </Modal>
  );
}
